import { render, staticRenderFns } from "./LocaleChangeComponent.vue?vue&type=template&id=1e3ee8ea&scoped=true"
import script from "./LocaleChangeComponent.vue?vue&type=script&lang=js"
export * from "./LocaleChangeComponent.vue?vue&type=script&lang=js"
import style0 from "./LocaleChangeComponent.vue?vue&type=style&index=0&id=1e3ee8ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e3ee8ea",
  null
  
)

export default component.exports